export const routes = {
  login: '/',
  loginCallback: '/login-callback',
  home: '/home',
  dashboard: '/dashboard',
  users: '/users',
  loans: '/loans',
  admins: '/admins',
  statements: '/statements',
  cards: '/cards',
  achRequests: '/ach-requests',
  pendingDrawdowns: '/drawdowns/pending',
  transactions: '/transactions',
  creditApplications: '/credit-applications',
  addFinalAppraisal: '/add-final-appraisal',
  partners: '/partners',
  userSearch: '/user-search',
  devices: '/devices',
  velocityControls: '/velocity-controls',
  programs: '/programs',
  primeRates: '/prime-rates',
  reconciliation: '/reconciliation',
  reports: '/reports',
  disputes: '/disputes',
  adminActions: '/admin-actions',
  loanData: '/loan-data',
  platformAccounts: '/ledger/platform-accounts',
  ledgerTransactions: '/ledger/transactions',
  development: '/development',
  statementStudio: '/development/statement-studio',
  timelineRuns: '/development/timeline-runs',
  obanJobs: '/development/oban-jobs',
};

export const routeConstant = {
  home: routes.home,
};
